import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const authHeaders = (token: string) => ({ Authorization: `Bearer ${token}` });

export interface TtlockAccount {
  managerId: number;
  ttlockUsername: string;
  isEnabled: boolean;
  tokenExpiresAt: string | null;
}

export interface TtlockLock {
  id: number;
  lockId: number;
  lockName: string;
  lockAlias: string | null;
  pinLength: number;
  allowedDigits: string;
  electricQuantity: number | null;
  isActive: boolean;
  lastSyncedAt: string | null;
}

export const getTtlockAccount = async (token: string): Promise<TtlockAccount | null> => {
  try {
    const res = await axios.get(`${API_BASE}/ttlock/account`, {
      headers: authHeaders(token),
      withCredentials: true,
    });
    return res.data;
  } catch {
    return null;
  }
};

export const connectTtlockAccount = async (
  token: string,
  username: string,
  password: string,
): Promise<TtlockAccount> => {
  const res = await axios.post(
    `${API_BASE}/ttlock/account`,
    { username, password },
    { headers: authHeaders(token), withCredentials: true },
  );
  return res.data;
};

export const getTtlockLocks = async (token: string): Promise<TtlockLock[]> => {
  const res = await axios.get(`${API_BASE}/ttlock/locks`, {
    headers: authHeaders(token),
    withCredentials: true,
  });
  return res.data;
};

export const syncTtlockLocks = async (token: string): Promise<TtlockLock[]> => {
  const res = await axios.post(`${API_BASE}/ttlock/locks/sync`, null, {
    headers: authHeaders(token),
    withCredentials: true,
  });
  return res.data;
};

export interface LockSettingsRequest {
  pinLength?: number;
  allowedDigits?: string;
}

export const updateTtlockLockSettings = async (
  token: string,
  lockId: number,
  settings: LockSettingsRequest,
): Promise<TtlockLock> => {
  const res = await axios.put(
    `${API_BASE}/ttlock/locks/${lockId}/settings`,
    settings,
    { headers: authHeaders(token), withCredentials: true },
  );
  return res.data;
};
